// extracted by mini-css-extract-plugin
export var container = "_dp-0";